import { useEffect, useState } from 'react'
import { subDays, format } from "date-fns"

const ACOutData = (origin, menuItens, month, year, row, token, refreshTick) => {
    const [acOut, setACOut] = useState({})

    useEffect(() => {
        getData().then(events => {
            if (events !== undefined) {
                // Gera labels dos últimos 30 dias, incluindo o dia inicial
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const labelsUltimos30Dias = [];
                for (let i = 29; i >= 0; i--) {
                    const d = subDays(today, i);
                    labelsUltimos30Dias.push(format(d, "dd/MM"));
                }

                // Lista de centrais
                const menuList = origin === "client" ? [{ 'id_central': menuItens }] : menuItens;
                const menuItensList = menuList.map(item => item.id_central);

                // Filtra eventos da central
                const requestCopy = events.filter(item => menuItensList.includes(item.central));

                // Monta dados para cada dia
                const data = labelsUltimos30Dias.map(label => {
                    const [dia, mes] = label.split('/');
                    const eventosNoDia = requestCopy.filter(ev =>
                        String(ev.day).padStart(2, '0') === dia &&
                        String(ev.month).padStart(2, '0') === mes
                    );
                    return eventosNoDia.length;
                });

                setACOut({
                    labels: labelsUltimos30Dias,
                    datasets: {
                        label: "SEM REDE AC",
                        data,
                        showLine: true,
                        borderColor: "",
                        backgroundColor: ""
                    }
                });
            }
        })
    }, [menuItens, token, refreshTick]);

    async function getData() {
        try {
            const endDate = new Date();
            endDate.setHours(0, 0, 0, 0);
            const startDate = subDays(endDate, 29);

            const startDateUTC = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()));
            const endDateUTC = new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()));

            const serialParam = origin === "client" && menuItens
                ? `&serialNumber=${encodeURIComponent(menuItens)}`
                : '';

            const response = await fetch(
                `${process.env.REACT_APP_URL}/events/relatory/by-period?occurrence=SEM REDE AC&startDate=${startDateUTC.toISOString().split('T')[0]}&endDate=${endDateUTC.toISOString().split('T')[0]}${serialParam}`,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Access-Control-Expose-Headers': '*',
                        'Authorization': 'Bearer ' + token
                    }
                }
            );
            if (!response.ok) return undefined;
            return await response.json();
        } catch (err) {
            console.error('Dashboard ACOutData: erro ao buscar dados', err);
            return undefined;
        }
    }

    return { acOut }
}

export default ACOutData
